import { Component, OnInit } from '@angular/core';
// import { getTime } from 'date-fns';
import { LandingServiceService } from 'src/app/Services/landing-service.service';
import * as myGlobals from "../../../../app.component";

@Component({
  selector: 'app-upcoming',
  templateUrl: './upcoming.component.html',
  styleUrls: ['./upcoming.component.scss']
})
export class UpcomingComponent implements OnInit {

  public baseUrl = myGlobals.baseFileUrl;

  events: any;
  upcomingEvents: any = [];
  pastEvents: any = [];

  todayDate = new Date().getTime();

  constructor(
    private landingService: LandingServiceService
  ) { }

  ngOnInit(): void {
    this.baseUrl = this.baseUrl + "/homepage/events";
    this.landingService.getUpcomingEvents().subscribe(data=>this.setEvents(data));
    // this.landingService.getAllEvents().subscribe(data => {
    //   this.setEvents(data);
    // })
  }

  setEvents(data) {
    this.upcomingEvents = data['upcomingEvent'];
    this.pastEvents = data['pastEvent'];
    // this.events.forEach(element => {
    //   var date = new Date(element['event_date']).getTime();
    //   var todDate = new Date(new Date().getTime()).setHours(0, 0, 0, 0);
    //   if (date < todDate) {
    //     this.pastEvents.push(element);
    //   } else {
    //     this.upcomingEvents.push(element);
    //   }
    // });

  }

}
